export default {
  first_name: {
    required: true,
    max: 30,
  },
  last_name: {
    required: true,
    max: 50,
  },
  email: {
    required: true,
    email: true,
  },
  phone: {
    required: true,
    regex: /^[+]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/,
  },
  birthday: {
    required: true,
  },
  street_house_number: {
    required: true,
    regex: /^(.+) (.+?)$/,
  },
  zip_code: {
    required: true,
    regex: /^[0-9]{5}$|^[0-9]{4}$|^[0-9]{4}\s?[A-Za-z]{2}$|^([0-9]{3} [0-9]{2})$|^([0-9]{2}-[0-9]{3})$|^[0-9a-zA-Z\s-]{4,10}$/,
  },
  city: {
    required: true,
    max: 50,
  },
  req: {
    required: true,
  },
};
